// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c3kr","clinicsSelect":"styles_clinicsSelect__265Uo"};